import { render, staticRenderFns } from "./AdminTimeSurvey.vue?vue&type=template&id=116b79ac&"
import script from "./AdminTimeSurvey.vue?vue&type=script&lang=js&"
export * from "./AdminTimeSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports